import AIPdfTool from "../components/AIPdfTool";

export default function AIAssistantPage() {

  return (

    <div className="max-w-7xl mx-auto">

      <AIPdfTool />

    </div>
  );
}